import { phoneExtGroup as phoneExtGroupService } from '@/services/api/phoneExtGroup.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { phoneExtGroupModel } from '@/models/api/phoneExtGroup.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    listByPhoneExt: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const PHONE_EXT_GROUP_MODULE = "api/phoneExtGroup";

// ACTIONS
export const GET_ALL_PHONE_EXT_GROUP = 'getAllPhoneExtGroup';
export const CREATE_PHONE_EXT_GROUP = 'createPhoneExtGroup';
export const GET_PHONE_EXT_GROUP = 'getPhoneExtGroup';
export const UPDATE_PHONE_EXT_GROUP = 'updatePhoneExtGroup';
export const UPDATE_PHONE_EXT_GROUP_STATUS = 'updatePhoneExtGroupStatus';
export const UPDATE_PHONE_EXT_GROUP_SEQUENCE = 'updatePhoneExtGroupSequence';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PHONE_EXT_GROUP_SUCCESS = "allPhoneExtGroupSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PHONE_EXT_GROUP_SUCCESS = "getPhoneExtGroupSuccess";

export const actions = {
    [GET_ALL_PHONE_EXT_GROUP]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        return phoneExtGroupService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PHONE_EXT_GROUP_SUCCESS, {data: result, filter});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE);
            });
    },
    [UPDATE_PHONE_EXT_GROUP_SEQUENCE]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return phoneExtGroupService
            .updateSequence(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('label.sequence')])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error')});
                commit(FAILURE);
            });
    },
    [CREATE_PHONE_EXT_GROUP]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return phoneExtGroupService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PHONE_EXT_GROUP]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return phoneExtGroupService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PHONE_EXT_GROUP_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PHONE_EXT_GROUP]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return phoneExtGroupService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_PHONE_EXT_GROUP_STATUS]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return phoneExtGroupService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_PHONE_EXT_GROUP_SUCCESS](state, {data, filter}) {
        const groups = data.success ? (data.data || [])
            .map(item => phoneExtGroupModel(item))
            .filter(item => item.isActive)
            .sort((a, b) => (a.sequence || 0) - (b.sequence || 0)) : [];
        state.listByPhoneExt = { ...state.listByPhoneExt, [filter.phoneExtUuid]: groups };
    },
    setPhoneExtGroupByPhoneExt(state, {phoneExtUuid, data}) {
        state.listByPhoneExt = { ...state.listByPhoneExt, [phoneExtUuid]: data };
    },
    [GET_PHONE_EXT_GROUP_SUCCESS](state, data) {
        state.details = phoneExtGroupModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};

